import React from 'react';
import pure from 'recompose/pure';
import DeleteIcon from '@material-ui/icons/Delete';
import useStyles from '../styles/MiniPaletteStyles';

const MiniPalette = ({
  paletteName,
  emoji,
  colors,
  openDialog,
  goToPalette,
  id,
}) => {
  const classes = useStyles();

  const miniColorBoxes = colors.map(color => (
    <div
      className={classes.miniColor}
      style={{ backgroundColor: color.color }}
      key={color.name}
    />
  ));

  const deletePalette = event => {
    event.preventDefault();
    event.stopPropagation();
    openDialog(id);
  };

  const handleClick = () => {
    goToPalette(id);
  };

  return (
    <div className={classes.root} onClick={handleClick}>
      <div className={classes.delete}>
        <DeleteIcon
          className={classes.deleteIcon}
          style={{ transition: 'all 0.3s ease-in-out' }}
          onClick={deletePalette}
        />
      </div>
      <div className={classes.colors}>{miniColorBoxes}</div>
      <h5 className={classes.title}>
        {paletteName} <span className={classes.emoji}>{emoji}</span>
      </h5>
    </div>
  );
};

export default pure(MiniPalette);
